<ng-container
  *ngIf="media; else fallback"
  [ngSwitch]="media.mediaType ?? media.contentType"
>
  <ng-container *ngSwitchCase="mediaType.Youtube">
    <atx-youtube-player
      class="embed-responsive embed-responsive-16by9 h-100 w-100"
      [url]="media.url"
      [play]="shouldVideoPlay"
      [muted]="videoAttributes.muted"
      [autoplay]="videoAttributes.autoplay"
      [loop]="videoAttributes.loop"
      (videoReady)="mediaReady.emit()"
      (error)="mediaReady.emit()"
      atxVisible
      (visible)="videoVisibilityChange($event)"
      [visibleEnabled]="pictureInPictureEnabled$ | async"
      [controls]="videoAttributes.controls"
      [disablePlaceholder]="videoAttributes.disablePlaceholder"
      [disabled]="videoAttributes.disabled"
    >
    </atx-youtube-player>
  </ng-container>

  <ng-container *ngSwitchCase="mediaType.Vimeo">
    <atx-vimeo-player
      [url]="media.url"
      [play]="shouldVideoPlay"
      [muted]="videoAttributes.muted"
      [controls]="videoAttributes.controls"
      [autoplay]="videoAttributes.autoplay"
      (videoReady)="mediaReady.emit()"
      (error)="mediaReady.emit()"
      atxVisible
      (visible)="videoVisibilityChange($event)"
      [visibleEnabled]="pictureInPictureEnabled$ | async"
    >
    </atx-vimeo-player>
  </ng-container>

  <ng-container *ngSwitchCase="mediaType.Video">
    <ng-container *ngIf="isVimeo; else videoPlayerRef">
      <!-- TODO change to epc-vimeo -->
      <atx-vimeo-player
        [url]="media.url"
        [play]="shouldVideoPlay"
        [muted]="videoAttributes.muted"
        [controls]="videoAttributes.controls"
        [autoplay]="videoAttributes.autoplay"
        (videoReady)="mediaReady.emit()"
        (error)="mediaReady.emit()"
        atxVisible
        (visible)="videoVisibilityChange($event)"
        [visibleEnabled]="pictureInPictureEnabled$ | async"
      >
      </atx-vimeo-player>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="mediaType.Directshow">
    <!-- TODO this is going to be removed once epic show player is in a separate module -->
    <ng-container
      *ngIf="epicShowPlayerTemplateRef; else videoPlayerRef"
      [ngTemplateOutlet]="epicShowPlayerTemplateRef"
    ></ng-container>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <atx-image
      atxCardImage="top"
      class="article-img"
      [imageUrl]="media.url"
      [maxWidth]="maxWidth"
      [maxHeight]="maxHeight"
      [imageBreakpoints]="imageBreakpoints"
      failedLoadIconSize="4x"
      [objectFit]="objectFit"
      (imageLoaded)="mediaReady.emit()"
      (error)="mediaReady.emit()"
    >
    </atx-image>
  </ng-container>

  <ng-template #videoPlayerRef>
    <atx-video-player
      class="embed-responsive embed-responsive-16by9 h-100 w-100"
      [url]="mediaUrl"
      [posterUrl]="posterUrl"
      [play]="shouldVideoPlay"
      [objectFit]="objectFit"
      [videoAttributes]="videoAttributes"
      (videoReady)="mediaReady.emit(); handleVideoStartTime()"
      (error)="mediaReady.emit()"
      atxVisible
      (visible)="videoVisibilityChange($event)"
      [visibleEnabled]="pictureInPictureEnabled$ | async"
    ></atx-video-player>
  </ng-template>
</ng-container>

<ng-template #fallback>
  <atx-image
    class="img-fluid h-100"
    class="article-img"
    [imageUrl]="fallbackImageUrl"
    failedLoadIconSize="3x"
    [maxWidth]="maxWidth"
    [maxHeight]="maxHeight"
    [imageBreakpoints]="imageBreakpoints"
    [objectFit]="objectFit"
  >
  </atx-image>
</ng-template>

<ng-content></ng-content>
